import { Injectable } from '@angular/core';

import { CursorType, DropZoneType } from '../../../enums';
import { DataTransferEffect } from './data-transfer-effect';
import { DragImage } from './drag-image';

export const getDropZoneType = (target: HTMLElement) => {
  if (!target) {
    return DropZoneType.NONE;
  }

  if (target.classList.contains(DropZoneType.COPY)) {
    return DropZoneType.COPY;
  }

  if (target.classList.contains(DropZoneType.MOVE)) {
    return DropZoneType.MOVE;
  }

  return DropZoneType.NONE;
};

export const getDropZoneParent = (event: MouseEvent) => {
  const target: any = event.target;
  const parent: HTMLElement = target.closest('.dropzone');

  return parent;
};

@Injectable({ providedIn: 'root' })
export class DragDropConfig {
  onDragStartClass: string = 'dnd-drag-start';
  onDragEnterClass: string = 'dnd-drag-enter';
  onDragDeniedClass: string = 'dnd-drag-denied';
  onDragWarningClass: string = 'dnd-drag-warning';
  onDragOverClass: string = 'dnd-drag-over';
  onSortableDragClass: string = 'dnd-sortable-drag';
  hiddenDropZone = 'hidden-dropzone';

  onDropEntered: string = 'dnd-drop-entered';

  dragEffect: DataTransferEffect = DataTransferEffect.MOVE;
  dropEffect: DataTransferEffect = DataTransferEffect.MOVE;
  dragCursor: string = 'move';
  dragImage: DragImage;
  defaultCursor: CursorType = CursorType.POINTER;
}
